import { reducer } from "./reducer"

export const serialNumberListingReducer = reducer
export * from "./types"


// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/reducers/index.ts